import { MutableRefObject, useEffect, useRef } from 'react'

export const useOutsideClick = (
  onOutsideClick: () => void
): MutableRefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleOutsideClick = (ev: MouseEvent) => {
      if (!ref.current || ref.current.contains(ev.target as Node)) return
      removeEventLister()
      onOutsideClick()
    }
    const removeEventLister = () =>
      document.removeEventListener('click', handleOutsideClick, false)
    document.addEventListener('click', handleOutsideClick, false)
    return removeEventLister
  }, [ref, onOutsideClick])

  return ref
}
